import { classnames } from 'tailwindcss-classnames';
import { TcDirectoryEligibilityProps } from '../_types';
import PediatricEligibilityTransferDetails from './_PediatricEligibilityTransferDetails';

const PediatricEligibility = ({ fields }: Pick<TcDirectoryEligibilityProps, 'fields'>) => {
  const acceptsPedTransfersMessage = fields?.anyTx?.value
    ? 'Does accept patients who were transplanted at another hospital'
    : 'Does not accept patients who were transplanted at another hospital';
  return (
    <>
      <b>Children</b>
      <ul className={classnames('p-4', 'space-y-2')}>
        {fields?.TransplantTypes?.value && (
          <li className={classnames('list-disc')}>
            {fields?.TransplantTypes?.value.replace(/\r\n/g, ' and ')} transplant recipients
          </li>
        )}
        {fields?.minTimePostTx?.value && (
          <li className={classnames('list-disc')}>
            {fields.minTimePostTx.value} after transplant.
          </li>
        )}
        {fields?.ageBoundary?.value ? (
          <li className={classnames('list-disc')}>
            Patients who were transplanted as a child at this center up to age{' '}
            {fields.ageBoundary.value}
          </li>
        ) : (
          <li className={classnames('list-disc')}>
            Patients who were transplanted as a child at this center with no upper age limit
          </li>
        )}
        <li className={classnames('list-disc')}>
          {acceptsPedTransfersMessage}
          {(fields?.pedTx?.value || fields?.adultAfterPedTx?.value) && (
            <PediatricEligibilityTransferDetails fields={fields} />
          )}
        </li>
      </ul>
    </>
  );
};
export default PediatricEligibility;
